import React, { useEffect, useState } from "react";
import axios from "axios";
import { base_url } from "../Auth/BackendAPIUrl";
import { Questionnaire } from "./Questionnaire";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ConfigToken } from "../Auth/ConfigToken";
import { questionnaireAction5, questionnaireAnswers } from "../../Redux/Action";
import { ToastContainer, toast } from "react-toastify";
import Blackupload from "../../Images/Questionnaire/upload.svg";
import Link from "../../Images/Questionnaire/icons8-link-26.png";
import useToastMessage from "../Pages/Toaster/Toaster";
import { Toaster } from "react-hot-toast";
import { fetchQuestionAnswer, updateOrderID } from "./questionnaire.slice";
import Loader from "../../Images/Home/load sticker.png";
import CloseIcon from "@mui/icons-material/Close";
import { handleAutoResize } from "./useAutoResize";

export const Questionnaire7 = ({
  formData,
  setFormData,
  changeLang,
  setChangeLang,
  handleBackNavigation,
}) => {
  const { showToast, showErrorToast, showSuccessToast } = useToastMessage();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentAnswer = useSelector((state) => state.questionnaire5);
  const answers4 = useSelector((state) => state.questionnaire4);
  const [isFilled, setIsFilled] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [linkError, setLinkError] = useState(null);
  const [errors, setErrors] = useState({});

  const [isFinishedQuestion, setIsFinished] = useState(false);

  /* NEW QUESTIONANSWER */

  const questionAndAnswers = useSelector(
    (state) => state?.questionAnswer?.questionAndAnswers || []
  );
  const orderId = useSelector((state) => state?.questionAnswer?.orderId);
  const [questionAnswer5, setQuestionAnswer5] = useState([]);

  useEffect(() => {
    if (questionAndAnswers.length > 0) {
      setQuestionAnswer5(questionAndAnswers);
    }
  }, [questionAndAnswers]);

  // Helper function to filter out duplicate questions across categories
  const filterDuplicateQuestions = (questions, currentCategory) => {
    const answeredQuestionIds = questionAndAnswers
      .filter(q => {
        const answer = q.answer;
        if (!answer) return false;
        if (typeof answer === "string" && answer.trim() !== "") return true;
        if (Array.isArray(answer) && answer.length > 0) return true;
        if (typeof answer === "object" && !Array.isArray(answer) && Object.keys(answer).length > 0) return true;
        return false;
      })
      .map(q => q.id);

    return questions.filter(q => {
      const isAnswered = answeredQuestionIds.includes(q.id);
      const categories = q.category?.split(',') || [];
      const hasMultipleCategories = categories.length > 1;
      
      if (isAnswered && hasMultipleCategories) {
        const answeredQuestion = questionAndAnswers.find(aq => aq.id === q.id);
        if (answeredQuestion) {
          const answeredCategories = answeredQuestion.category?.split(',') || [];
          return answeredCategories.includes(currentCategory);
        }
      }
      return true;
    });
  };

  const countWords = (str) => {
    if (!str || typeof str !== "string") return 0;
    return str.trim().split(/\s+/).filter((word) => word.length > 0).length;
  };

  /* NEW QUESTIONANSWER */

  useEffect(() => {
    window.onbeforeunload = () => {
      sessionStorage.setItem("isReload", "true");
    };
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  // Detect refresh on mount
  useEffect(() => {
    if (sessionStorage.getItem("isReload") === "true") {
      sessionStorage.removeItem("isReload");
      navigate("/questionnaire/1");
    }
  }, [navigate]);

  useEffect(() => {
    setFormData(currentAnswer);
  }, []);

  const showToastMessage = () => {
    showErrorToast(
      changeLang === "ar" ? "القيمة مطلوب" : "The Value is required!",
      "#D83D99"
    );
  };

  // const validateFields = () => {
  //   ;
  //   const unansweredRequiredQuestions = questionAnswer5
  //     .slice(21, 24)
  //     .filter((q) => {
  //       if (q.id === 23) {
  //         return (
  //           q.required && (q.answer.document || q.answer.document.trim() === "")
  //         );
  //       }
  //       else if (q.id === 24) {
  //         return (
  //           q.required && (q.answer && q.answer.trim() !== "")
  //         );
  //       } else {
  //         return q.required && (q.answer || q.answer.trim() === "");
  //       }
  //     });

  //   if (unansweredRequiredQuestions.length > 0) {
  //     const element = document.getElementById(
  //       `question_${unansweredRequiredQuestions[0]?.id}`
  //     );
  //     setIsFilled(unansweredRequiredQuestions[0]?.id);
  //     if (element) {
  //       element.scrollIntoView({ behavior: "smooth" });
  //     }
  //     showToastMessage();
  //     return false;
  //   }
  //   return true;
  // };

    const isValidUrl = (url) => {
        const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/i;
        return urlPattern.test(url);
    };

  const validateFields = () => {
    // Check for word count limit
    const wordLimitExceeded = questionAnswer5.some((q) => {
      const answer = q.answer;
      if (q.id === 21) return countWords(answer?.link) > 70;
      if (q.answer_type === "file") return false;
      return countWords(q.answer) > 70;
    });

    if (wordLimitExceeded) {
      const questionWithLimitError = questionAnswer5.find((q) => {
        const answer = q.answer;
        if (q.id === 21) return countWords(answer?.link) > 70;
        if (q.answer_type === "file") return false;
        return countWords(q.answer) > 70;
      });
      if (questionWithLimitError) {
        setErrors((prev) => ({
          ...prev,
          [questionWithLimitError.id]: changeLang === "ar" ? "يجب ألا يتجاوز النص 70 كلمة" : "Text should not exceed 70 words",
        }));
        setIsFilled(questionWithLimitError.id);
        const element = document.getElementById(`question_${questionWithLimitError.id}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
      return false;
    }

    const unansweredRequiredQuestions = questionAnswer5
      .filter(f => f.category.split(',').includes('final'))
      .filter((q) => {
          const answer = q.answer;
          // Special validation for question 21 (file upload or link)
          if (q.answer_type === 'file/link' || q.id === 21) {
              const hasLink = answer?.link && answer.link.trim() !== "";
              const hasDocuments = answer?.documents && answer.documents.length > 0;

              // If link exists, validate it
              if (hasLink && !isValidUrl(answer.link.trim())) {
                  return true; // Invalid link, mark as invalid
              }

              if (q.required) {
                return !hasLink && !hasDocuments;
              }
              return false;

          }
          if (!q.required) return false;

        return !q.answer || q.answer.trim() === "";
      });

    if (unansweredRequiredQuestions.length > 0) {
      const element = document.getElementById(
        `question_${unansweredRequiredQuestions[0]?.id}`
      );
      setIsFilled(unansweredRequiredQuestions[0]?.id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
      // Show specific error for invalid link
      if ((unansweredRequiredQuestions[0]?.answer_type === 'file/link' || unansweredRequiredQuestions[0]?.id === 21) && unansweredRequiredQuestions[0]?.answer?.link) {
          setLinkError(changeLang === "ar" ? "الرجاء إدخال رابط صالح!" : "Please enter a valid link!")
        showErrorToast(
          changeLang === "ar" ? "الرجاء إدخال رابط صالح!" : "Please enter a valid link!",
          "#D83D99"
        );
      } else {
        showToastMessage();
      }
      return false;
    }

    return true;
  };

  const handleChange = (id, value) => {
    if (countWords(value) > 70) {
      setErrors((prev) => ({
        ...prev,
        [id]:
          changeLang === "ar"
            ? "يجب ألا يتجاوز النص 70 كلمة"
            : "Text should not exceed 70 words",
      }));
    } else {
      setErrors((prev) => {
        const updated = { ...prev };
        if (updated[id] === (changeLang === "ar" ? "يجب ألا يتجاوز النص 70 كلمة" : "Text should not exceed 70 words")) {
          delete updated[id];
        }
        return updated;
      });
    }

    // Handle question 21 (file/link type) - link input
    const question = questionAnswer5.find((q) => q.id === id);
    if (question?.answer_type === "file/link" && id === 21) {
      setQuestionAnswer5((prev) =>
        prev.map((ele) =>
          ele.id === id
            ? {
                ...ele,
                answer: {
                  ...ele.answer,
                  link: value,
                },
              }
            : ele
        )
      );
    } else {
      setQuestionAnswer5((prev) =>
        prev.map((ele) => (ele.id === id ? { ...ele, answer: value } : ele))
      );
    }
  };

  const handleLinkBlur = (questionId) => {
    const question = questionAnswer5.find(q => q.id === questionId);
    const link = question?.answer?.link?.trim();

    if (link) {
      if (isValidUrl(link)) {
        showSuccessToast(
          changeLang === "ar" ? "تم إضافة الرابط بنجاح!" : "Link added successfully!",
          "#1BA56F"
        );
      } else {
          setLinkError(changeLang === "ar" ? "الرجاء إدخال رابط صالح!" : "Please enter a valid link!")
        showErrorToast(
          changeLang === "ar" ? "الرجاء إدخال رابط صالح!" : "Please enter a valid link!",
          "#D83D99"
        );
      }
    }
  };

  const onBackClick = async () => {
    dispatch(fetchQuestionAnswer(questionAnswer5));
    if (handleBackNavigation) {
      handleBackNavigation(7);
    } else {
      navigate(`/questionnaire/${6}`, {
        state: {
          questionnaireData4: answers4,
          orderId: location.state?.orderId,
        },
      });
    }
  };

  const FinishClick = async () => {
    let finalFormData = {
      answers: newUpdatedAns,
      language: localStorage.getItem("lang") === "ar" ? "arabic" : "english",
      status: "submit",
      ...(orderId && { orderId }),
    };
    if (!validateFields()) {
      return;
    }
    try {
      setIsFinished(true);
      const response = await axios.post(
        `${base_url}/api/questionnaire/create`,
        finalFormData,
        ConfigToken()
      );
      if (response.data.status === 200) {
        localStorage.removeItem("reduxState");
        localStorage.removeItem("orderId");
        dispatch(fetchQuestionAnswer([]));
        dispatch(updateOrderID(""));
      }
      setIsFinished(false);
      navigate("/thankyou");
    } catch (error) {
      setIsFinished(false);
      console.error("Error submitting data:", error);
    }
  };

  let newUpdatedAns = questionAnswer5.map((ele) => {
    return {
      id: ele.id,
      answers: ele.answer,
    };
  });

  const onSaveLaterClick = async () => {
    try {
      let data = {
        answers: newUpdatedAns,
        status: "not submitted",
        orderId: orderId,
      };
      const response = await axios.post(
        `${base_url}/api/questionnaire/create`,
        data,
        ConfigToken()
      );
      if (response.status === 200) {
        dispatch(questionnaireAction5(formData));
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const removeDocument = (indexToRemove, id) => {
    setQuestionAnswer5((prev) =>
      prev.map((ele) =>
        ele.id === id
          ? {
              ...ele,
              answer: {
                ...ele.answer,
                documents: ele.answer.documents.filter(
                  (_, i) => i !== indexToRemove
                ),
              },
            }
          : ele
      )
    );
  };

  const uploadFile = async (e, id, field) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    setIsUploading(true);
    try {
    const uploadedFiles = await Promise.all(
      files.map(async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("file_name", file.name);

        const response = await axios.post(
          `${base_url}/api/upload_file/`,
          formData,
          ConfigToken()
        );

        return {
          docName: file.name,
          document: response.data.file_url,
        };
      })
    );

    setQuestionAnswer5((prev) =>
      prev.map((ele) =>
        ele.id === id
          ? {
              ...ele,
              answer: {
                ...ele.answer,
                documents: [
                  ...(ele.answer?.documents || []), // existing files
                  ...uploadedFiles, // new files
                ],
              },
            }
          : ele
      )
    );
    } catch (error) {
      console.error("Error uploading files:", error);
      showErrorToast(
        changeLang === "ar" ? "خطأ في رفع الملفات" : "Error uploading files",
        "#D83D99"
      );
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div>
      <div>
        {isFinishedQuestion && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              // backgroundColor: "transparent",
              backgroundColor: "rgba(0, 0, 0, 0.4)",

              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              pointerEvents: "auto",
              userSelect: "none",
              zIndex: 9999,
            }}
          >
            {/* <img
              src={ourWorkBranding}
              alt="loader-round-icon"
              style={{ width: 200, height: 200 }}
              className="loader"
            /> */}
            <img className="loader" src={Loader} alt="loader-round-icon"></img>
          </div>
        )}
      </div>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      <ToastContainer />
      <Questionnaire
        pageNo={7}
        Qlang={changeLang}
        setQLang={setChangeLang}
        storeAnswers={answers4}
        orderId={location.state?.orderId}
        onBackClick={onBackClick}
        onNextClick={FinishClick}
        onSaveLaterClick={onSaveLaterClick}
        formData={formData}
        setFormData={setFormData}
        questions={filterDuplicateQuestions(questionAnswer5.filter(f => f.category.split(',').includes('final')), 'final').sort((a, b) => a.sort_order - b.sort_order).map((question, index) => (
          <div
            className="questions"
            key={question.id}
            id={`question_${question.id}`}
          >
            <p
              className={`questions-title  xs:w-[90%] sm:w-full md:w-full mx-auto ${
                index === 0 ? "mt-[1%]" : "mt-[2%]"
              }`}
            >
              {changeLang === "ar"
                ? question?.question_arabic
                : question.question}
              {question?.required && (
                <span>
                  <sup>*</sup>
                </span>
              )}
            </p>

            {question.id === 21 ? (
              <>
                <div
                  className={`${
                    window?.innerWidth <= 500 ? "flex-col" : "flex-row"
                  } gap-[20px] flex w-full justify-center items-start ${
                      isFilled === question?.id
                          ? "border-[#D83D99] border-b-[2px]"
                          : `${
                              window?.innerWidth <= 475
                                  ? "border-b-[1px]"
                                  : "border-b-[2px]"
                          } border-black`
                  }`}
                >
                  <div
                    className="color-input"
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "10px",
                      position: "relative",
                      // height: "65px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder={changeLang === "ar" ? "روابط" : "Links"}
                      value={question?.answer?.link}
                      onChange={(e) =>
                        handleChange(question.id, e.target.value)
                      }
                      onBlur={() => handleLinkBlur(question.id)}
                      style={{
                        padding: "8px",
                        border: "1px solid #000",
                        outline: "none",
                        width: window.innerWidth <= 441 ? "250px" : "300px",
                        borderRadius: "0px",
                      }}
                    />
                    <div className={`word-counter ${countWords(question?.answer?.link) > 70 ? "limit-exceeded" : ""}`}>
                      {changeLang === "ar" ? "كلمات" : "Words"}: {countWords(question?.answer?.link)} / 70
                    </div>
                    {question.id in errors && (
                      <p className="text-[#D83D99]">{errors[question.id]}</p>
                    )}
                    <button
                      style={{
                        padding:
                          window.innerWidth <= 441 ? "0" : "8px 16px",
                        backgroundColor: "transparent",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer",
                        margin:
                          window.innerWidth <= 441
                            ? changeLang === "ar"
                              ? "-45px 80% 0px 0%"
                              : "-45px 0px 0px 80%"
                            : changeLang === "ar"
                            ? "-55px 80% 0px 0%"
                            : "-55px 0px 0px 80%",
                      }}
                    >
                      <img src={Link}></img>
                    </button>
                      {linkError && <p className={'text-[#D83D99]'}>{linkError}</p>}
                  </div>
                  <>
                    <p
                      className={`border-1  h-[45px] lg:text-[18px] md:text-[18px] xs:text-[14px] uppercase
                            ${
                              window?.innerWidth <= 500
                                ? "w-[61%]"
                                : "w-[300px]"
                            }
                          !border-[#000000] flex items-center justify-center text-[#000000] cursor-pointer lg:ml-2 lg:mt-4  md:ml-2 md:mt-4  xs:ml-0 xs:mt-0 p-[5px] ${
                            isUploading ? "opacity-50 cursor-not-allowed" : ""
                          }`}
                      onClick={() => {
                        if (!isUploading) {
                          document
                            .getElementById(`file-${question.id}`)
                            .click();
                        }
                      }}
                    >
                      <input
                        type="file"
                        hidden
                        multiple
                        name="file"
                        id={`file-${question.id}`}
                        onChange={(e) => uploadFile(e, question.id, "file")}
                        className=""
                        disabled={isUploading}
                      />
                      {isUploading ? (
                        <div className="flex items-center">
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-black mr-2"></div>
                          {changeLang === "ar" ? "جاري الرفع..." : "Uploading..."}
                        </div>
                      ) : (
                        <>
                          <img
                            className="h-[25px] w-[40px]"
                            src={Blackupload}
                            alt="Upload Icon"
                          />
                          {changeLang === "ar"
                            ? "إضافة المحتوى"
                            : "Upload Content"}
                        </>
                      )}
                    </p>
                  </>
                </div>
                {question?.answer?.documents?.length > 0 && (
                  <div className="flex flex-wrap">
                    {question.answer.documents.map(({ docName }, i) => (
                      <div
                        key={i}
                        className="bg-black text-[14px] text-white py-1 px-2 mr-2 mb-2 flex items-center"
                      >
                        {docName}
                        <CloseIcon
                          onClick={() => removeDocument(i, question.id)}
                          className="ml-2 cursor-pointer"
                        />
                      </div>
                    ))}
                  </div>
                )}
              </>
            ) : question?.answer_type === "file" ? (
              <>
                <div
                  className={`question-input ${
                    isFilled === question?.id
                      ? "border-[#D83D99] border-b-[2px]"
                      : `${
                          window?.innerWidth <= 475
                            ? "border-b-[1px]"
                            : "border-b-[2px]"
                        } border-black`
                  }`}
                >
                  <>
                    <p className="text-[#a9a9a9] mt-[-25px] text-[18px]">
                      {question?.placeholder}
                    </p>
                    <div className="flex justify-center items-center">
                      <p
                        className={`border-1 lg:text-[18px] md:text-[18px] xs:text-[14px] uppercase font-Helvetica font-[400]
                            ${
                              window?.innerWidth <= 500
                                ? "w-[75%]"
                                : "w-[300px]"
                            } 
                          !border-[#000000] flex items-center justify-center  text-[#000000] cursor-pointer ml-2 mt-3 p-2 ${
                            isUploading ? "opacity-50 cursor-not-allowed" : ""
                          }`}
                        onClick={() => {
                          if (!isUploading) {
                            document.getElementById(`file-${question.id}`).click();
                        }
                        }}
                      >
                        <input
                          type="file"
                          hidden
                          multiple
                          name="file"
                          id={`file-${question.id}`} // Use a unique ID for each input
                          onChange={(e) => uploadFile(e, question.id, "file")}
                          disabled={isUploading}
                        />

                        {isUploading ? (
                          <div className="flex items-center">
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-black mr-2"></div>
                            {changeLang === "ar" ? "جاري الرفع..." : "Uploading..."}
                          </div>
                        ) : (
                          <>
                        <img
                          className="h-[25px] w-[40px]"
                          src={Blackupload}
                          alt="Upload Icon"
                        />
                        {changeLang === "ar"
                          ? "تحميل المحتوى"
                          : "Upload Content"}
                          </>
                        )}
                      </p>
                    </div>
                    {/* <p className="lg:text-[18px] md:text-[18px] xs:text-[14px] font-[400]">
                      {question?.answer?.docName}
                    </p> */}
                    {question?.answer?.documents?.length > 0 && (
                      <div className="flex flex-wrap justify-center">
                        {question.answer.documents.map(({ docName }, i) => (
                          <div
                            key={i}
                            className="bg-black text-[14px] text-white py-1 px-2 mr-2 mb-2 flex items-center"
                          >
                            {docName}
                            <CloseIcon
                              onClick={() => removeDocument(i, question.id)}
                              className="ml-2 cursor-pointer"
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                </div>
              </>
            ) : (
              <>
                <textarea
                  placeholder={question?.placeholder}
                  className={`question-input ${
                    isFilled === question?.id
                      ? "border-[#D83D99] border-b-[2px]"
                      : `${
                          window?.innerWidth <= 475
                            ? "border-b-[1px]"
                            : "border-b-[2px]"
                        } border-black`
                  }`}
                  value={question?.answer}
                  onChange={(e) => {
                    handleChange(question.id, e.target.value);
                    handleAutoResize(e, 200);
                  }}
                  onInput={(e) => handleAutoResize(e, 200)}
                  rows={1}
                />
                <div className={`word-counter ${countWords(question.answer) > 70 ? "limit-exceeded" : ""}`}>
                  {changeLang === "ar" ? "كلمات" : "Words"}: {countWords(question.answer)} / 70
                </div>
                {question.id in errors && (
                    <p className="text-[#D83D99]">{errors[question.id]}</p>
                )}
              </>
            )}
          </div>
        ))}
        bgTitle={changeLang === "ar" ? "ملاحظات أخيرة" : "Final Thoughts"}
      />
    </div>
  );
};
